/**
 * AUTO-GENERATED from schema.json — DO NOT EDIT
 * Source: Video Content Section (video_content_section)
 * Run `yarn workspace @library/cms-blocks cms:types` to regenerate
 */

import { z } from 'zod'
import { CmsAssetSchema, RichTextContentSchema } from '../../types/contentstack-zod'
import { RawCmsCtaSchema } from '../../cta'

export const VideoContentSectionFieldsSchema = z
  .object({
    heading: z.string().max(120),
    heading_level: z.enum(['h1', 'h2']),
    body: RichTextContentSchema.nullish(),
    video: CmsAssetSchema,
    poster_image: CmsAssetSchema.nullish(),
    captions: CmsAssetSchema,
    cta: RawCmsCtaSchema.nullish(),
  })
  .passthrough()
